import { Col, Row } from '@opendoor/atoms/box';
import { cn } from '@opendoor/atoms/utils';
import { Picture } from 'components/shared/performance/pictures';

const Marker = ({
  imageSource,
  preload = false,
  lazy = true,
  className,
}: {
  imageSource: string;
  preload?: boolean;
  lazy?: boolean;
  className?: string;
}) => {
  return (
    <Col className={cn('absolute', className)}>
      <Row className="w-full items-center justify-center">
        <Picture
          preload={preload}
          lazy={lazy}
          sources={[{ srcSet: imageSource, media: '(min-width: 0px)', key: imageSource }]}
          objectFit="cover"
        />
      </Row>
    </Col>
  );
};

export default Marker;
